import React, { useCallback, useEffect, useRef, useState } from 'react';
import CommonDataTable, { parseServerPagedResponse } from '../../Common/CommonDataTable';
import { useSelector } from 'react-redux';
import { base64ToString, Decrypt_Id_Name, getShowingDateText, getShowingWithOutTime, stringToBase64 } from '@/Components/Common/Utility';
import { useDispatch } from 'react-redux';
import { get_LocalStoreData } from '@/redux/actions/Agency';
import { get_Report_Approve_Officer_Data, get_ScreenPermissions_Data } from '@/redux/actions/IncidentAction';
import { fetchPostData } from '@/Components/hooks/Api';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PendingReportReviewModal from './Components/PendingReportReviewModal';
import { PendingReportReviewModalOld } from './ReportPendingApprovalOld';

const shouldUseOldReportPendingApproval = (isNewFRW, caseID) => !isNewFRW || !!caseID;

function ReportPendingApproval({ isPreview, reportPendingApprovalEditAllowed = false, isNewFRW = true }) {

  const uniqueId = sessionStorage.getItem('UniqueUserID') ? Decrypt_Id_Name(sessionStorage.getItem('UniqueUserID'), 'UForUniqueUserID') : '';

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const useRouterQuery = () => {
    const params = new URLSearchParams(useLocation().search);
    return {
      get: (param) => params.get(param)
    };
  };

  const query = useRouterQuery();
  var IncID = query?.get("IncId");
  var IncNo = query?.get("IncNo");
  if (!IncID) IncID = 0;
  else IncID = parseInt(base64ToString(IncID));
  const effectiveScreenPermission = useSelector((state) => state.Incident.effectiveScreenPermission);
  const localStoreData = useSelector((state) => state.Agency.localStoreData);
  const [clickedRow, setClickedRow] = useState(null);
  const [loginAgencyID, setLoginAgencyID] = useState('');
  const [loginPinID, setLoginPinID] = useState();
  const [editval, setEditval] = useState([]);
  const [narrativeID, setNarrativeID] = useState();
  const [incidentID, setIncidentID] = useState();
  const [arrestID, setArrestID] = useState();
  const [useOfForceID, setUseOfForceID] = useState("");
  const [caseID, setCaseID] = useState();
  const [queData, setqueData] = useState();
  const [modelStatus, setModelStatus] = useState(false);
  const [useOldReviewModal, setUseOldReviewModal] = useState(false);
  const [WrittenForID, setWrittenForID] = useState();
  const [loder, setLoder] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [reportApprovalStatus, setreportApprovalStatus] = useState(false);
  const [checkapproveStatus, setcheckapproveStatus] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [incomingCadSearch, setIncomingCadSearch] = useState('');
  const lastPaginationRef = useRef({ page: 1, pageSize: 10 });

  useEffect(() => {
    if (!localStoreData?.AgencyID || !localStoreData?.PINID) {
      if (uniqueId) { dispatch(get_LocalStoreData(uniqueId)); }
    }
  }, []);

  useEffect(() => {
    if (!localStoreData?.AgencyID || !localStoreData?.PINID) return;
    setLoginAgencyID(localStoreData?.AgencyID);
    setLoginPinID(localStoreData?.PINID);
    dispatch(get_ScreenPermissions_Data("RD103", localStoreData?.AgencyID, localStoreData.PINID));

    setreportApprovalStatus(localStoreData?.ReportApproval);
    setcheckapproveStatus(localStoreData?.IsLevel);
  }, [localStoreData]);

  const columns = [
    {
      name: 'Review',
      cell: row => (
        <div className="text-start">
          <button
            type="button"
            className="btn btn-sm btn-dark w-100 mb-1"
            style={{
              backgroundColor: "#001f3f",
              color: "#fff",
              fontSize: '11px',
              ...(effectiveScreenPermission?.[0]?.Changeok === 1 ? {} : { opacity: 0.65, cursor: 'not-allowed' }),
            }}
            disabled={effectiveScreenPermission?.[0]?.Changeok === 0}
            title={effectiveScreenPermission?.[0]?.Changeok === 1 ? undefined : 'View only — change permission is required to review.'}

            onClick={() => {
              if (effectiveScreenPermission?.[0]?.Changeok === 0) return;
              const UseOfForceID = row?.UseofForceID != null && Number(row.UseofForceID) > 0
                ? row.UseofForceID
                : "";
              GetSingleData(row?.NarrativeID, UseOfForceID);
              setWrittenForID(row?.WrittenForID);
              setNarrativeID(row?.NarrativeID);
              setIncidentID(row?.IncidentID);
              setArrestID(row?.ArrestID);
              setUseOfForceID(UseOfForceID);
              setCaseID(row?.CaseID);
              setUseOldReviewModal(shouldUseOldReportPendingApproval(isNewFRW, row?.CaseID || row?.Iscase));
            }}
          >
            Review
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: 'Incident # ', cell: row => {
        return (
          row?.Iscase ? (
            <span
            onClick={() =>
              navigate(`/inc-case-management?IncId=${stringToBase64(row?.IncidentID)}&IncNo=${(row?.IncidentNumber)}&IncSta=${true}&CaseManagementPage=caseReport&CaseId=${stringToBase64(row?.CaseID)}`)
            }
            style={{
              color: '#007bff',
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
            title="Go to Incident"
          >
            {row?.IncidentNumber}
          </span>
          ) :
          <span
            onClick={() =>
              navigate(`/Inc-Home?IncId=${stringToBase64(row?.IncidentID)}&IncNo=${row?.IncidentNumber}&IncSta=${true}`)
            }
            style={{
              color: '#007bff',
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
            title="Go to Incident"
          >
            {row?.IncidentNumber}
          </span>
        );
      },
      selector: row => row.IncidentNumber,
      sortable: true,
      wrap: true,
      grow: 0, width: "105px",
    },
    {
      name: 'Arrest # ', cell: row => {
        return (
          <span
            onClick={() => {
              <>
                {
                  row?.ArrestNumber && (
                    navigate(`/Arrest-Home?IncId=${stringToBase64(row?.IncidentID)}&IncNo=${(row?.IncidentNumber)}&IncSta=${true}&ArrestId=${stringToBase64(row?.ArrestID)}&ArrNo=${stringToBase64(row?.ArrestNumber)}`)
                  )}
              </>
            }}
            style={{
              color: '#007bff',
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
            title="Go to Arrest"
          >
            {row?.ArrestNumber}
          </span>
        );
      }, sortable: true, grow: 0, width: "140px",
    },
    { name: 'Seq #', selector: row => row.sequence, sortable: true, grow: 0, width: '80px', },
    { name: 'Report Source', selector: row => row.Iscase ? "Case Management" : 'Incident', sortable: true, width: '140px' },
    { name: 'Approving Officer', selector: row => row.ApproverName || row.Approve_Officer, sortable: true },
    {
      name: 'Report Type',
      width: "200px",
      selector: row => row.NarrativeDescription,
      sortable: true,

      cell: row => {
        const desc = row.NarrativeDescription?.toLowerCase();

        let backgroundColor = 'transparent';
        let color = 'inherit';

        if (desc === 'initial narrative') {
          backgroundColor = '#fde047'; // yellow-300
          color = 'inherit';
        } else if (desc === 'public narrative') {
          backgroundColor = '#86efac'; // green-300
          color = 'inherit';
        } else if (desc === 'supplementary narrative') {
          backgroundColor = '#bfdbfe'; // blue-200
          color = 'inherit';
        }
        else if (desc === 'press release') {
          backgroundColor = '#f87171'; // red-400
          color = 'inherit';
        }
        else if (desc === 'use of force') {
          backgroundColor = '#007bff';
          color = 'inherit';
        }
        return (
          <span
            style={{
              backgroundColor,
              color,
              padding: '2px 6px',
              borderRadius: '4px',
              display: 'inline-block',
              whiteSpace: "nowrap"

            }}
          >
            {row.NarrativeDescription}
          </span>
        );
      },
    },
    { name: 'Submitted By', selector: row => row.SummittedBy || row.CreateOfficer, sortable: true },
    { name: 'Submitted Date/Time', selector: row => row.CreatedDtTm ? getShowingDateText(row.CreatedDtTm) : '', sortable: true },
    {
      name: 'Due Date',
      selector: row => row.DueDate ? getShowingWithOutTime(row.DueDate) : '',
      sortable: true,
      cell: row => (
        <span style={{ color: 'red' }}>
          {row.DueDate ? getShowingWithOutTime(row.DueDate) : ''}
        </span>
      ),
    },
    {
      name: 'Elapsed Days',
      selector: row => row.ElapsedDay,
      sortable: true,
      cell: row => {
        let color = '';
        if (row.ElapsedDay > row.DueStatus) {
          color = '#FF0000';
        }
        return (
          <span
            style={{
              color,
            }}
          >
            {row.ElapsedDay}
          </span>
        );
      }
    },
    { name: 'Opened By', selector: row => row.OpenedBy, sortable: true },
  ];

  const get_Data_Que_Report = useCallback((OfficerID, agencyId, page, size, incomingCadSearch) => {
    if (OfficerID == null || agencyId == null) {
      return;
    }
    const pageNum = page ?? lastPaginationRef.current.page;
    const pageSizeVal = size ?? lastPaginationRef.current.pageSize;
    lastPaginationRef.current = { page: pageNum, pageSize: pageSizeVal };
    setLoder(false);
    const val = {
      OfficerID,
      AgencyID: agencyId,
      PageNumber: pageNum,
      PageSize: pageSizeVal,
      IncidentNumber: incomingCadSearch,
    };
    fetchPostData('/IncidentNarrativeReport/GetPendingReport', val)
      .then((res) => {
        const { rows, total } = parseServerPagedResponse(res);
        setqueData(rows);
        setTotalRows(total);
        setFilteredData([]);
        setLoder(true);
      })
      .catch(() => {
        setqueData([]);
        setTotalRows(0);
        setLoder(true);
      });
  }, []);

  const onTablePagination = useCallback((page, size) => {
    lastPaginationRef.current = { page, size };
    if (!loginPinID || !loginAgencyID) return;
    get_Data_Que_Report(loginPinID, loginAgencyID, page, size, incomingCadSearch);
  }, [loginPinID, loginAgencyID, get_Data_Que_Report, incomingCadSearch]);

  // Re-fetch (debounced) whenever the search text changes. Skips the first ready
  // run so it doesn't duplicate the table's initial pagination load.
  const isFirstSearchRef = useRef(true);
  useEffect(() => {
    if (!loginPinID || !loginAgencyID) return;
    if (isFirstSearchRef.current) {
      isFirstSearchRef.current = false;
      return;
    }
    const handler = setTimeout(() => {
      get_Data_Que_Report(loginPinID, loginAgencyID, 1, lastPaginationRef.current.pageSize, incomingCadSearch);
    }, 500);
    return () => clearTimeout(handler);
  }, [incomingCadSearch, loginPinID, loginAgencyID, get_Data_Que_Report]);

  const GetSingleData = (NarrativeID, UseOfForceID) => {

    const val = UseOfForceID ? { UseOfForceID } : { NarrativeID, 'OfficerID': loginPinID, 'AgencyID': loginAgencyID, };
    fetchPostData('IncidentNarrativeReport/GetSingleData_NarrativeApprove', val).then((res) => {
      if (res) {
        setEditval(res);
        setModelStatus(true);
      } else {
        setEditval([]);
      }
    })
  }

  const conditionalRowStyles = [
    {
      when: row => row === clickedRow,
      style: {
        backgroundColor: '#001f3fbd',
        color: 'white',
        cursor: 'pointer',
      },
    },
  ];

  const onMasterPropClose = () => {
    navigate('/dashboard-page');
  }

  return (
    <>
      <div className="col-12 que-reports col-sm-12">
        <div className="text-end mt-2 d-flex w-100" style={{ justifyContent: "space-between", alignItems: "center", }}  >
          <div className="d-flex align-items-center">
            <div className="d-flex align-items-center">
              {isPreview && (
                <span className="mr-2 ">
                  <svg width="32" height="32" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
                    <rect width="128" height="128" rx="100" fill="#D6ECFF" />
                    <path d="M48 36h44v52H52v8h48V36h-8v44H48z" fill="#E30613" />
                    <rect x="36" y="24" width="56" height="72" rx="4" fill="#0B2F80" />
                    <rect x="48" y="38" width="32" height="6" rx="3" fill="white" />
                    <rect x="48" y="50" width="40" height="6" rx="3" fill="white" />
                    <rect x="48" y="62" width="40" height="6" rx="3" fill="white" />
                    <rect x="48" y="74" width="24" height="6" rx="3" fill="white" />
                  </svg>
                </span>
              )}
              <span className="fw-bold mb-0 " style={{ fontSize: '15px', fontWeight: '700', color: '#334c65' }}>Report Pending Approval</span>
            </div>
          </div>

          {isPreview ? (
            <div className="d-flex align-items-center">
              <div className="position-relative mr-3">
                <input
                  type="text" name="IncidentNumber" id="IncidentNumber"
                  className="form-control py-1 new-input" placeholder="Search......"
                  onChange={(e) => { setIncomingCadSearch(e.target.value); }}
                  autoComplete="off"
                />
              </div>
              <h5 className="mb-0 mr-3" style={{ fontSize: "18px", fontWeight: "600", color: '#334c65' }}>
                {totalRows}
              </h5>
              <Link to="/report-pending-approval">
                <button className="see-all-btn mr-1 see_all-button" style={{ fontSize: "12px", padding: "4px 8px" }}>See All</button>
              </Link>
            </div>
          ) : (
            <button
              className="btn btn-outline-dark mr-3"
              style={{ backgroundColor: "#001f3f", color: "#fff" }}
              onClick={onMasterPropClose}
            >
              Close
            </button>
          )}
        </div>
        <div className="pt-2 que-reports-datatable mt-2">
          <CommonDataTable
            className={isPreview ? 'table-responsive_pastdues datatable-grid' : ''}
            data={queData?.length > 0 ? queData : []}
            columns={columns}
            useAppDefaults
            stickyHeader
            manageServerPagination
            resetPaginationKey={loginAgencyID && loginPinID ? `${loginAgencyID}-${loginPinID}` : ''}
            onPaginationChange={onTablePagination}
            totalRows={totalRows}
            loading={!loder}
            defaultPageSize={100}
            paginationRowsPerPageOptions={[100, 200, 300, 400, 500]}
            noDataComponent={effectiveScreenPermission?.[0]?.DisplayOK ? 'No records found' : 'You don’t have permission to view data'}
            conditionalRowStyles={conditionalRowStyles}
            onRowClicked={setClickedRow}
            // defaultSortFieldId={8}
            defaultSortAsc={false}
          />
        </div>
        {modelStatus && editval?.length > 0 && (
          isNewFRW && editval?.[0]?.Iscase
            ? <PendingReportReviewModalOld checkapproveStatus={checkapproveStatus} reportApprovalStatus={reportApprovalStatus} editval={editval} get_Data_Que_Report={get_Data_Que_Report} WrittenForID={WrittenForID} narrativeID={narrativeID} loginAgencyID={loginAgencyID} loginPinID={loginPinID} setModelStatus={setModelStatus} useOfForceID={useOfForceID} caseID={caseID} arrestID={arrestID} />
            : <PendingReportReviewModal checkapproveStatus={checkapproveStatus} reportApprovalStatus={reportApprovalStatus} editval={editval} get_Data_Que_Report={get_Data_Que_Report} WrittenForID={WrittenForID} narrativeID={narrativeID} incidentID={incidentID} loginAgencyID={loginAgencyID} loginPinID={loginPinID} setModelStatus={setModelStatus} useOfForceID={useOfForceID} caseID={caseID} arrestID={arrestID} />
        )}
      </div>
    </>
  )
}

export default ReportPendingApproval
